import { forwardRef } from 'react';
import SelectUnwrapped, { ISelectProps as ISelectUnwrapProps } from '../Select/SelectUnwrapped';

export type IMultiSelectProps = ISelectUnwrapProps<true>;

export const MultiSelect = forwardRef<HTMLDivElement, IMultiSelectProps>(function InnerMultiSelect(
    { value, ...rest },
    ref
) {
    return (
        <SelectUnwrapped<true>
            data-testid={`multiselect-${rest.name}`}
            {...rest}
            value={value ?? []}
            innerRef={ref}
            multiple={true}
        />
    );
});
